<script lang="ts">
  import type { StyleValue } from 'vue'
  import { defineComponent, computed } from 'vue'
  import { getNamespace } from '../../../utils/global-config'
  import { addUnit } from '../../../shared/utils'

  export default defineComponent({
    name: 'BnIconAppEdit',
    props: {
      size: {
        type: [Number, String],
        default: undefined
      },
      rotate: {
        type: Number,
        default: undefined
      },
      spin: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: undefined
      }
    },
    setup(props) {
      const ns = getNamespace('icon')

      const styles = computed(() => {
        const styles: StyleValue = {}
        if (props.size) {
          styles.fontSize = addUnit(props.size)
        }

        if (props.rotate) {
          styles.transform = `rotate(${props.rotate}deg)`
        }

        if (props.color) {
          styles.color = props.color
        }
        return styles
      })

      const cls = computed(() => [
        ns,
        {
          [`${ns}-loading`]: props.spin
        }
      ])

      return {
        cls,
        styles
      }
    }
  })
</script>

<template>
  <i :class="cls" :style="styles">
    <svg
      width="25px"
      height="24px"
      viewBox="0 0 25 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>编组 14</title>
      <defs>
        <filter id="filter-1">
          <feColorMatrix
            in="SourceGraphic"
            type="matrix"
            values="0 0 0 0 0.612817 0 0 0 0 0.649587 0 0 0 0 0.725459 0 0 0 1.000000 0"
          ></feColorMatrix>
        </filter>
      </defs>
      <g id="抓潜拓客" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="编组-14" transform="translate(-762.000000, -297.000000)" filter="url(#filter-1)">
          <g transform="translate(763.000000, 297.000000)">
            <g
              id="编组-18"
              transform="translate(11.544639, 11.161329) rotate(40.000000) translate(-11.544639, -11.161329) translate(8.544639, 4.161329)"
              stroke="#646B7A"
            >
              <path
                id="矩形"
                d="M5.5,0.5 L5.5,11.1481159 L3,13.3356159 L0.5,11.1481159 L0.5,0.5 L5.5,0.5 Z"
              ></path>
              <rect id="矩形" x="0.5" y="0.5" width="5" height="3"></rect>
            </g>
            <rect id="矩形" fill="#0056FF" x="6" y="18" width="10" height="1"></rect>
          </g>
        </g>
      </g>
    </svg>
  </i>
</template>
